'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _DefaultTrip = require('./DefaultTrip.scss');

var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = require('react-intl');

var _RatingPoint = require('../General/RatingPoint/RatingPoint');

var _RatingPoint2 = _interopRequireDefault(_RatingPoint);

var _WishlistButton = require('../General/Buttons/WishlistButton');

var _WishlistButton2 = _interopRequireDefault(_WishlistButton);

var _helpers = require('utils/helpers');

var _media = require('utils/media');

var _trip = require('utils/trip');

var _helpers2 = require('utils/helpers.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Trip: {
    displayName: 'Trip'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/DefaultTrip.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Trip = _wrapComponent('Trip')((_dec = (0, _reactCssModules2.default)(_DefaultTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Trip, _Component);

  function Trip(props) {
    (0, _classCallCheck3.default)(this, Trip);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Trip.__proto__ || (0, _getPrototypeOf2.default)(Trip)).call(this, props));

    _this.renderPriceMobile = _this.renderPriceMobile.bind(_this);

    if (!(typeof _this.renderPriceMobile === 'function')) {
      throw new TypeError('Value of "this.renderPriceMobile" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.renderPriceMobile));
    }

    _this.renderPriceContent = _this.renderPriceContent.bind(_this);

    if (!(typeof _this.renderPriceContent === 'function')) {
      throw new TypeError('Value of "this.renderPriceContent" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.renderPriceContent));
    }

    _this.renderTrip = _this.renderTrip.bind(_this);

    if (!(typeof _this.renderTrip === 'function')) {
      throw new TypeError('Value of "this.renderTrip" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderTrip));
    }

    _this.isVerified = _this.isVerified.bind(_this);

    if (!(typeof _this.isVerified === 'function')) {
      throw new TypeError('Value of "this.isVerified" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.isVerified));
    }

    _this.requestBook = _this.requestBook.bind(_this);

    if (!(typeof _this.requestBook === 'function')) {
      throw new TypeError('Value of "this.requestBook" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.requestBook));
    }

    return _this;
  }

  (0, _createClass3.default)(Trip, [{
    key: 'isVerified',
    value: function isVerified() {
      var trip = this.props.trip;

      var user = trip.user_id;
      var count = 0;
      if (user && user.verification) {
        if (user.verification.mobile_verified) {
          count += 1;
        }
        if (user.verification.id_card_verified) {
          count += 1;
        }
        if (user.verification.email_verified) {
          count += 1;
        }
        if (user.verification.facebook_verified) {
          count += 1;
        }
      }
      if (count >= 2) {
        return true;
      }
      return false;
    }
  }, {
    key: 'requestBook',
    value: function requestBook(e) {
      e.preventDefault();
      this.props.requestBook();
    }
  }, {
    key: 'renderPriceMobile',
    value: function renderPriceMobile(currency) {
      var _props = this.props,
          siteConfigs = _props.siteConfigs,
          prices = _props.prices,
          trip = _props.trip;

      return _react3.default.createElement(
        'div',
        { styleName: 'price-mobile-container' },
        _react3.default.createElement(
          'span',
          { styleName: 'person-mobile' },
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.per_person' })
        ),
        _react3.default.createElement(
          'span',
          { styleName: 'price-mobile' },
          prices.displayPrice,
          ' ',
          siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
        ),
        trip.discount_percentage > 0 ? _react3.default.createElement(
          'span',
          { styleName: 'cross-price-mobile' },
          prices.displaySeasonedPrice
        ) : null
      );
    }
  }, {
    key: 'renderPriceContent',
    value: function renderPriceContent(currency) {
      var _props2 = this.props,
          siteConfigs = _props2.siteConfigs,
          prices = _props2.prices,
          trip = _props2.trip;

      return _react3.default.createElement(
        'div',
        { styleName: 'trip-content-price' },
        trip.discount_percentage > 0 ? _react3.default.createElement(
          'span',
          { styleName: 'cross-price' },
          _react3.default.createElement(
            'span',
            null,
            prices.displaySeasonedPrice,
            ' ',
            siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
          )
        ) : null,
        _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'span',
            { styleName: 'price' },
            prices.displayPrice,
            ' ',
            siteConfigs.fixYuan && currency === 'CNY' ? '元' : currency
          ),
          '\xA0',
          _react3.default.createElement(
            'span',
            { styleName: 'person' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'all-tags' },
          (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
            return _react3.default.createElement(
              'div',
              { key: index, styleName: tag.style },
              _react3.default.createElement('i', null),
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
            );
          })
        )
      );
    }
  }, {
    key: 'renderTrip',
    value: function renderTrip() {
      var pinImage = require('theme/images/icons/location-pin.png');
      var pinImageMobile = require('theme/images/icons/location.png');
      var defaultImage = require('theme/images/default-img.png');
      var _props3 = this.props,
          trip = _props3.trip,
          currency = _props3.currency,
          isWishlisted = _props3.isWishlisted,
          siteConfigs = _props3.siteConfigs,
          disableWishlist = _props3.disableWishlist,
          thumbnailCurrency = _props3.thumbnailCurrency,
          tripBookNow = _props3.tripBookNow,
          disableBookNow = _props3.disableBookNow;

      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
      var transportation = (0, _trip.getTransportation)(trip.transportation);
      return _react3.default.createElement(
        'div',
        { ref: 'root', styleName: 'trip-container', id: trip._id },
        _react3.default.createElement(
          'div',
          { styleName: 'trip-picture' },
          _react3.default.createElement('img', { src: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard'), styleName: 'trip-picture-img', alt: trip.name }),
          trip.video_url && _react3.default.createElement('div', { styleName: 'play-icon' }),
          _react3.default.createElement(
            'div',
            { styleName: 'trip-picture-shadow' },
            _react3.default.createElement(
              'div',
              { styleName: 'trip-picture-shadow-flex' },
              _react3.default.createElement(
                'div',
                { styleName: 'trip-picture-location-point' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'location' },
                  _react3.default.createElement('img', { src: pinImage, width: '10', height: '15', alt: 'pin' }),
                  _react3.default.createElement(
                    'span',
                    null,
                    this.props.from && this.props.from !== trip.destination_location ? 'From ' + this.props.from : trip.destination_location
                  )
                ),
                trip.rating > 0 && _react3.default.createElement(
                  'div',
                  { styleName: 'review-flex' },
                  _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
                  _react3.default.createElement(
                    'span',
                    { styleName: 'review-count' },
                    '(',
                    trip.review_count,
                    ' ',
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.reviews' }),
                    ')'
                  )
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'lx-picture-mobile' },
                !siteConfigs.tripHideLx && _react3.default.createElement(
                  'div',
                  { styleName: 'trip-content-lx-pic-container' },
                  this.isVerified() && _react3.default.createElement('div', { styleName: 'verify-icon' }),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'trip-content-lx-pic' },
                    _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'avatarTripCard') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
                  )
                )
              ),
              trip.discount_percentage ? _react3.default.createElement(
                'div',
                { styleName: 'trip-picture-discount' },
                _react3.default.createElement(
                  'p',
                  { styleName: 'discount-amount' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
                )
              ) : null,
              _react3.default.createElement(
                'div',
                { styleName: 'trip-price-mobile' },
                thumbnailCurrency ? this.renderPriceMobile(thumbnailCurrency) : this.renderPriceMobile(currency),
                trip.discount_percentage ? _react3.default.createElement(
                  'div',
                  { styleName: 'price-off-mobile' },
                  _react3.default.createElement(
                    'p',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
                  )
                ) : null
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'mobile-bg-action' },
            _react3.default.createElement(
              'div',
              null,
              (0, _helpers2.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip && _react3.default.createElement(
                'div',
                { styleName: 'tag-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'instant-tag-band' },
                  _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
                  _react3.default.createElement(
                    'span',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.available_tomorrow' })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  null,
                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
                )
              ),
              trip.is_instant_confirmation && _react3.default.createElement(
                'div',
                { styleName: 'tag-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'instant-tag-band' },
                  _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
                  _react3.default.createElement(
                    'span',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'search.search_filter.extra_conditions.instant_booking' })
                  )
                ),
                _react3.default.createElement(
                  'div',
                  null,
                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
                  _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
                )
              ),
              trip.tmt_tag && _react3.default.createElement(
                'div',
                { styleName: 'tag-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'tmt-tag-band' },
                  _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.exclusive' })
                ),
                _react3.default.createElement(
                  'div',
                  null,
                  _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-top' }),
                  _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-bottom' })
                )
              ),
              trip.tags.some(function (s) {
                return s.match(/_staff_pick$/);
              }) && _react3.default.createElement(
                'div',
                { styleName: 'tag-container' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'feature-tag-band' },
                  _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.feature' })
                ),
                _react3.default.createElement(
                  'div',
                  null,
                  _react3.default.createElement('div', { styleName: 'feature-tag-arrow-top' }),
                  _react3.default.createElement('div', { styleName: 'feature-tag-arrow-bottom' })
                )
              ),
              trip.rating > 0 && _react3.default.createElement(
                'div',
                { styleName: 'rating-mobile' },
                _react3.default.createElement(_RatingPoint2.default, { point: trip.rating }),
                _react3.default.createElement(
                  'span',
                  { styleName: 'review-count' },
                  '(',
                  trip.review_count,
                  ')'
                )
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'wishlist-mobile' },
              !disableWishlist && _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'trip-content' },
          _react3.default.createElement(
            'h3',
            { className: 'trip-preview-name', styleName: 'trip-content-header' },
            _react3.default.createElement(
              'span',
              null,
              trip.name
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'location-mobile' },
              _react3.default.createElement('img', { src: pinImageMobile, width: '10', height: '15', alt: 'pin' }),
              _react3.default.createElement(
                'span',
                null,
                this.props.from && this.props.from !== trip.destination_location ? 'From ' + this.props.from : trip.destination_location
              )
            )
          ),
          !siteConfigs.tripHideLx && _react3.default.createElement(
            'div',
            { styleName: 'trip-content-lx' },
            _react3.default.createElement(
              'div',
              { styleName: 'trip-content-lx-pic-container' },
              this.isVerified() && _react3.default.createElement('div', { styleName: 'verify-icon' }),
              _react3.default.createElement(
                'div',
                { styleName: 'trip-content-lx-pic' },
                _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'avatarTripCard') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
              )
            ),
            _react3.default.createElement(
              'span',
              null,
              trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'content-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'content-row-wrapper' },
              siteConfigs.tripHideLx && _react3.default.createElement(
                'div',
                { styleName: 'content-row' },
                _react3.default.createElement('i', { styleName: 'view-icon' }),
                _react3.default.createElement(
                  'span',
                  { styleName: 'content-label' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.view' }),
                  ': '
                ),
                _react3.default.createElement(
                  'span',
                  { styleName: 'content-value' },
                  trip.view_count || 0
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'content-row' },
                _react3.default.createElement('i', { styleName: 'duration-icon' }),
                _react3.default.createElement(
                  'span',
                  { styleName: 'content-label' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.duration.label' }),
                  ': '
                ),
                _react3.default.createElement(
                  'span',
                  { styleName: 'content-value' },
                  (0, _trip.getHour)(trip.duration),
                  ' ',
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.hour' })
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'content-row' },
                _react3.default.createElement('i', { styleName: trip.transportation === 'Public Transportation' ? 'public-transportation-icon' : 'private-car-icon' }),
                _react3.default.createElement(
                  'span',
                  { styleName: 'content-label' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.transportation.label' }),
                  ': '
                ),
                _react3.default.createElement(
                  'span',
                  { styleName: 'content-value' },
                  transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
                )
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'content-row-no-margin' },
              _react3.default.createElement('i', { styleName: 'activity-icon' }),
              _react3.default.createElement(
                'span',
                { styleName: 'content-label' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.activities.label' }),
                ': '
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'activities-values' },
                trip.activities && trip.activities.map(function (act) {
                  return _react3.default.createElement(
                    'span',
                    { styleName: 'activity', key: act },
                    act
                  );
                })
              )
            )
          ),
          (0, _helpers.getTripLabels)(trip).length > 0 && _react3.default.createElement(
            'div',
            { styleName: 'all-tags-mobile' },
            (0, _helpers.getTripLabels)(trip).map(function (tag, index) {
              return _react3.default.createElement(
                'div',
                { key: index, styleName: tag.style },
                _react3.default.createElement('i', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: tag.templateId })
              );
            })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'trip-content-action' },
            thumbnailCurrency ? this.renderPriceContent(thumbnailCurrency) : this.renderPriceContent(currency),
            _react3.default.createElement(
              'div',
              { styleName: 'wishlist-container' },
              !disableWishlist && _react3.default.createElement(_WishlistButton2.default, { active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
            )
          ),
          tripBookNow && !disableBookNow && _react3.default.createElement(
            'div',
            { styleName: 'trip-book-now-action' },
            _react3.default.createElement(
              'span',
              { styleName: 'more-info-btn' },
              'More Info'
            ),
            _react3.default.createElement(
              'span',
              { styleName: 'book-now-btn', onClick: this.requestBook },
              'Book Now'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          trip = _props4.trip,
          target = _props4.target;

      if (trip.is_external) {
        return _react3.default.createElement(
          'a',
          { href: trip.external_url, target: target },
          this.renderTrip()
        );
      }
      return _react3.default.createElement(
        _Link2.default,
        { to: '/trip/' + trip.slug, styleName: 'link', target: target },
        this.renderTrip()
      );
    }
  }]);
  return Trip;
}(_react2.Component), _class2.propTypes = {
  tripBookNow: _react2.PropTypes.bool,
  disableBookNow: _react2.PropTypes.bool,
  disableWishlist: _react2.PropTypes.bool,
  from: _react2.PropTypes.string,
  target: _react2.PropTypes.string,
  currency: _react2.PropTypes.string,
  thumbnailCurrency: _react2.PropTypes.string,
  trip: _react2.PropTypes.object,
  prices: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object,
  isWishlisted: _react2.PropTypes.object,
  requestBook: _react2.PropTypes.func
}, _class2.defaultProps = {
  target: null
}, _temp)) || _class));

exports.default = Trip;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Trip/DefaultTrip.js
// module id = 132
// module chunks = 1 2 9 13 14 24